import { useMemo } from 'react';
import { useInitialState } from '../contexts/InitialStateContext';
import { useParams } from 'react-router';
import { CategorySlug } from '../config';
import { useSearch } from './useSearch';

export const useSelectedCategory = () => {
  const initialState = useInitialState();
  const { isSearchActive } = useSearch();
  const { categorySlug: categorySlugParam } = useParams();

  return useMemo(() => {
    const categories = initialState.book?.categories ?? [];
    const categorySlug = isSearchActive
      ? undefined
      : categorySlugParam ?? CategorySlug.DEFAULT;

    return categories.find((a) => a.slug === categorySlug);
  }, [initialState.book?.categories, isSearchActive, categorySlugParam]);
};
